const menu = {
  key: "businessRules",
  route: "/business-rules",
  label: "sidebar.businessRules",
  icon: "faScaleBalanced",
  group: "documentation",
  order: 20,
};

export default menu;
